<template>
  <div class="bodys" v-if="body_show">
    <public-header :colors="'#fff'" :headimg="headImg"></public-header>
    <div class="men_detail">
      <img src="@a/cur-banner.png" />
      <div class="cur1">
        <div class="cur1_t clearfix">
          <div class="cur1_l">
            <span>优惠价：</span>￥{{data.courseprice}}
          </div>
          <div class="cur1_r">
            <span></span>原价999，限时优惠200
          </div>
        </div>
        <div class="cur1_b">
          {{data.begintime}} 开课
        </div>
      </div>
      <div class="cur2">
        <div class="cur2_t">
          在度过了埋头拼杀的职场生存期后
          <br/>90%的职场人都会遇到以下问题
        </div>
        <img src="@a/cur3.png" class="cur_img1" />
        <ul class="cur_ul1">
          <li class="clearfix">
            <i></i>
            <div class="ul1_r">
              向上发展的职位和机会开始变少，单单靠拼时间、拼努力，<span>已经不能够快速提升自己身价。 </span>
            </div>
          </li>
          <li class="clearfix
">
            <i></i>
            <div class="ul1_r">对未来的发展方向重新定位，开始思考：<span>对
                            现在做的事情是不是最合适？还有没有其他更好的选择？
                        </span>
            </div>
          </li>
          <li class="clearfix
">
            <i></i>
            <div class="ul1_r">
              零零散散做了许多事情，能力有提升，也取得了一些成绩，但是
              <span>
                            希望更清晰自己的核心竞争力。
                        </span>
            </div>
          </li>
          <li class="clearfix">
            <i></i>
            <div class="ul1_r">
              局限于自己 眼前的选择 ，对于 整个行业环境 、趋势不了解，
              <span>
                            不知道自己的发展路径还有哪些可能性 。</span>
            </div>
          </li>
        </ul>
        <div class="cur_rt">
          这些困惑，与初入职场时相比，更高级也更复杂
          <br/> 埋头向前冲时它们经常隐形
          <br/> 不解决却又总会在某个加班的夜晚再次出现
          <br/> 让你反复纠结和内耗
        </div>
        <div class="cur_tr">
          <h2><span></span>其实你需要<span></span></h2>
          <div class="cur_rtb">
            深入了解自我
            <br/> &
            <br/> 更高维度理解职业的一整套解决方案
          </div>
        </div>
        <img src="@a/cur6.png" class="imr_cur6" />
      </div>
      <div class="cur2 cur2_tv">
        <h2>
                                           个人战略<br/>商业价值重塑<br />||
                    </h2>
        <div class="cur2_tb">
          <div class="cur2_tn">
            30天职业成长系统
            <br/> +
            <br/> 4大真实项目
            <br/> +
            <br/> 8堂必修课程
            <br/> +
            <br/> 7人小组学习体系
            <br/> +
            <br/> 12个职业发展工具
          </div>
        </div>
      </div>
      <div class="cur_son">
        <span>01</span>
        <div class="cur_sonr">
          4大真实项目
          <br/>快速到达职业发展新阶段
        </div>
      </div>
      <div class="cur2 cur3_tv">
        <h2>
                        对成年人而言，<span>问题，是学习的起点。而解决问题，是提升能力的最佳方式。</span>与普通课程不同，<span>《个人战略-商业价值重塑》以“做到”为目标</span>全程围绕项目任务展开：
                    </h2>
        <ul class="cur3_ul">
          <li>
            <div class="cur_li clearfix">
              <h2>项目一：职业定位与身价评估 </h2><img src="@a/cur7.png" />
            </div>
            <h3>1. 重新梳理定位，锁定自己的职场坐标 <br/>
2. 站在行业链条上，重新看待自己的市场身价<br/>
3.找到未来发展的3条可能职业路径，和不同路径的职业回报和能力要求</h3>
          </li>
          <li>
            <div class="cur_li clearfix">
              <h2>项目二 职场榜样对标分析</h2><img src="@a/cur8.png" />
            </div>
            <h3>
                            1. 理解个人生涯发展曲线及底层规律<br/>
2. 通过分析职场榜样，找到自己发展的突破策略<br/>
3. 掌握跨越生涯拐点所需要的能力
                        </h3>
          </li>
          <li>
            <div class="cur_li clearfix">
              <h2>项目三 竞争力分析与2~3年发展路书</h2><img src="@a/cur9.png" />
            </div>
            <h3>1. 了解自身能力优劣势及职业驱动力<br/>
2.根据优劣势设计职业发展路径，确立未来2-3年职业目标<br/>
3.根据目标确立关键事件节点，并思考可能遇到的障碍和解决计划</h3>
          </li>
          <li>
            <div class="cur_li clearfix">
              <h2>项目四 个人品牌增值方案</h2><img src="@a/cur10.png" />
            </div>
            <h3>1. 收获一份能清晰、最大化展现自己价值的简历<br/>
2. 得到适用于社交媒体和实际生活的高价值自我介绍<br/>
3. 提炼个人品牌，形成“个人品牌金字塔”方案
                        </h3>
          </li>
        </ul>
      </div>
      <div class="cur_son cur_son1">
        <span>02</span>
        <div class="cur_sonr">国内顶尖级职业发展专家古典老师亲自讲授
          <br/>个人发展必修课</div>
      </div>
      <div class="cur2 cur3_tv">
        <h2>为了让大家更高效地完成四个项目任务，古典老师亲自研发并录制了<span>《个人战略-商业价值重塑》课。</span></h2>
        <ul class="cur4_ul">
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第一节: 个人商业价值的本质 #</h3>
              <p>1.如何正确理解职业
                <br/> 2.个人商业价值的本质和评估公式
                <br/> 3.职业中最该关注的核心价值
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第二节: 个人发展自我定位 #</h3>
              <p>
                1.行企职三维度定位，找到高价值区(地利)
                <br/> 2.找到职业中永恒不变和缓慢变化的趋势(天时)
                <br/> 3.生涯四看
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第三节: 跃迁之路：职业发展线路图 #</h3>
              <p>
                1.标杆人物分析法，对标发展关键节点
                <br/> 2.如何通过一手资料洞察职业生涯
                <br/> 3.如何正确利用个人发展拐点实现跃迁
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第四节: 个人发展破局 #</h3>
              <p>
                1.案例分析：一个人如何破局
                <br/> 2.破局的能力：内驱、能力、眼界、聚集
                <br/> 3.找到自己的发展破局点
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第五节: 核心竞争力分析 #</h3>
              <p>
                1. 自我优劣势分析方法
                <br/> 2. 找到你的内驱力
                <br/> 3. 分析你的成就事件
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第六节: 制定未来3年个人发展路书 #</h3>
              <p>
                1.开启你的“奥德赛之旅”
                <br/> 2.为自己设置里程碑事件
                <br/> 3.个人发展中的障碍清单及解决方法
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第七节: 个人品牌的树立和打造 #</h3>
              <p>
                1.个人品牌的定义和核心
                <br/> 2.如何打造独特的个人品牌
                <br/> 3.个人品牌金字塔模型
              </p>
            </div>
          </li>
          <li class="clearfix">
            <div class="ul4_l">
              <h1><span></span></h1>
              <h3></h3>
            </div>
            <div class="ul4_r">
              <h3># 第八节: 多场景下打造个人影响力 #</h3>
              <p>
                1.如何讲好你的“个人品牌故事”
                <br/> 2.如何设置个人品牌传播路径
                <br/> 3.如何在不同场景下输出自己的品牌？
              </p>
            </div>
          </li>
        </ul>
        <div class="gd">
          <img src="@a/cur11.png" />
          <p>新精英生涯创始人，著名生涯规划师，顶尖个人职业发展顾问，众多知名企业高管教练，得到专栏《超级个体》主理人。</p>
          <img src="@a/cur12.png" class="gd_i" />
          <h3>“在跑出生存期后，突破当前瓶颈，抬头看路，变的前所未有的重要——你应该知道自己未来要去哪，值多少钱，以及该如何有步骤的提升，并链接上对于未来的关键资源。</h3>
          <h1>——古典</h1>
        </div>
      </div>
      <div class="cur_son">
        <span>03</span>
        <div class="cur_sonr"> 职场教练全程服务指导
          <br/>真正为学习效果负责</div>
      </div>
      <div class="cur2 cur3_tv">
        <h2>
                            项目助教均为<span>拥有行业认证资质的生涯规划师</span>
                            （课程外单次咨询价格每小时500元起），在30天项目时间里将<span>
                            全程支持与陪伴，成为你的专属职场教练
                        </span>
                    </h2>
        <img src="@a/cur13.png" class="zd_i" />
        <img src="@a/cur14.png" class="zd_v" />
        <p class="zs">(生涯规划师认证证书)</p>
      </div>
      <div class="cur_son">
        <span>04</span>
        <div class="cur_sonr">
          7人小组学习体系
          <br/>基于共同目标的深度合作
        </div>
      </div>
      <div class="cur2 cur3_tv">
        <h2>

                            将行职业相关
                        <span>
                            、能力相当的7位同学分为一组
                        </span>
                            。每个人拥有
                        <span>
                            特定角色
                        </span>
                            保证有效交流
                            <span>
                            结识高质量人脉。
                        </span>
                    </h2>
        <img src="@a/cur15.png" class="hz_v" />
      </div>
      <div class="cur_son">
        <span>05</span>
        <div class="cur_sonr">12个内部工具首次公开
          <br/>加速个人发展的独家利器</div>
      </div>
      <div class="cur2 cur3_tv">
        <ul class="lq">
          <li><span></span>行职业调查模板</li>
          <li><span></span>职业群族分类与资料库</li>
          <li><span></span>个人身价评估方式</li>
          <li><span></span>用户调研访谈模板</li>
          <li><span></span>生涯发展路径分析报告</li>
          <li><span></span>破局能力模型</li>
          <li><span></span>个人能力测评</li>
          <li><span></span>个人驱动力测评</li>
          <li><span></span>职业发展路书案例</li>
          <li><span></span>优势发展案例</li>
          <li><span></span>个人简历2.0模板</li>
          <li><span></span>个人品牌金字塔模板</li>
        </ul>
      </div>
      <div class="cur2">
        <div class="cur2_t cur2_nv">《个人战略-商业价值重塑》</div>
        <h3 class="nv_v">适合已经度过职场生存期的职场人</h3>
        <img src="@a/cur3.png" class="cur_img2" />
        <ul class="cur_ul5">
          <li class="clearfix">
            <span>1</span>想提升自己身价，找到方法和最短路径</li>
          <li class="clearfix">
            <span>1</span>想提升核心竞争力，知道自己优势在哪，怎样发挥</li>
          <li class="clearfix">
            <span>3</span>想跳槽换工作，知道该如何选择一个新机会</li>
          <li class="clearfix">
            <span>4</span>想明确发展路径，知道该如何自我定位</li>
        </ul>
      </div>
      <div class="cur2 cur6">
        <h1>独立、系统的思考个人发展<br/>
是每个行业大神和高手的必修课<br/>
这种能力，是他们一次次突破形成跃迁的关键能力<br/>
既然你每个月都花10小时看电影、见朋友和发呆<br/>
                        <span>为什么不用同样的时间来思考下自己的发展？<br/>决胜未来2年的人生？</span></h1>
        <img src="@a/cur18.png" class="cur_18" />
        <a class="cur_href">立即加入</a>
        <h3 class="lp">领跑你的同龄人</h3>
      </div>
      <div class="cur_xz">
        <h2>课程须知</h2>
        <p>1.课程均为录播，不受时间和空间的限制，且能够确保呈现给大家的课程是经过不断打磨和优化的最好内容。付费后可永久回听。
          <br/>2.为确保导师能够提供高质量服务，《个人战略-商业价值重塑》会定期开营，学习时间为1个月。
          <br/> 3.本产品为虚拟内容服务，不支持退款，请您理解。
        </p>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="into_btn_box">
      <div class="into_btn" v-if="!data.ishavedbuy">
        <a class="free_learn" @click="free_learn" href="javascript:;">免费试学</a>
        <a class="sign_immediately" @click="signHandle" v-if="data.surplus>0">
                    立即报名<br />
                </a>
        <a class="sign_immediately" v-else>预约报名</a>
      </div>
      <router-link class="into_project" :to="url_substying(data.ishavedbuy) + '?cid=' + cid" v-else>进入【项目】</router-link>
    </div>
    <!-- 引入卡片弹窗 -->
    <public-pop :imgUrl="data.sharebuy_placard" :text_assistant="'长按添加助理<br/>领取更多'" :insert_text="'课程资料'" :text_card="'长按专属海报分享出去，每入学1位立即奖励80元'" :type="3"></public-pop>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <public-ewm :assistant_show="assistant_show" :ewm_img="ewm_img"></public-ewm>
  </div>
</template>
<script>
import {
  statistics
} from "@/api/public";
import {
  coursedetail
} from "@/api/course"
import {
  project_click_time
} from "@/api/course"
import {
  statistic_next
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
import { getStorage, setStorage } from "@/utils/tools"

export default {
  data() {
      return {
        body_show: false,
        cid: "",
        headImg: "",
        data: {},
        phone: null,
        code: null,
        source: '',
        pdk: '',
        aspx: '',
        assistant_show: false,
        ewm_img: ""
      }
    },
    methods: {
      pullData() {
        coursedetail({
            bid: this.$route.query.bid
          })
          .then((data) => {
            this.body_show = true;
            this.data = data;
            this.cid = data.id;
            this.source = this.$route.query.source || '';
            if (!data.subscribe && data.qrcode.length > 0) {
              this.assistant_show = true;
              this.ewm_img = data.qrcode;
            };
            // 分享
            this.pdk = this.$route.query.pdk || '';
            this.aspx = this.$route.query.aspx || '';
            // 用户图像
            this.headImg = data.userdetail.headimgurl;
            this.cacheUserConfig = {
              pdk: data.pdk,
              aspx: data.aspx
            };
            shareCon("course",this);
            // 神策统计
            sensors.track('courseDetails', {
              classification: data.bigcoursename,
              classification_id: this.$route.query.bid,
              channel_name: this.source || '',
              course_id: this.cid,
              course_name: data.coursename,
              share_user_id: this.pdk || '',
              course_discount_price: data.courseprice,
              course_original_price: data.originalprice,
              course_starttime: data.begintime
            })
          })
      },
      // 立即报名
      signHandle() {
        this.statistical("coursebtn");
        // 神策统计--点击立即报名按钮
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.data.bigcoursename,
          classification: this.data.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        });
        // 把神策数据存到本地缓存
        let godPolicy = {
          course_id: this.cid,
          classification: this.data.bigcoursename,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        };
        setStorage('godPolicy', 'godPolicy', godPolicy);
        if (this.data.mobilestatus) {
          // 是否需要验证验证码
          this.$refs.handle.need_verify = this.data.need_verify || false;
          // 判断用户手机号是否已验证
          this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
          this.$refs.handle.show = true;

        } else {
          this.$refs.handle.pay()
        }
      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
      statistic_() {
        statistic_next({
            cid: this.data.id
          })
          .then();
      },
      // 免费试学
      free_learn() {
        project_click_time({
            cid: this.data.id
          })
          .then((data) => {
            // 免费试学跳转
            this.$router.push("/list?cid=" + this.cid);
          });
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('/');
        let last = url_.lastIndexOf('.');
        let x = url_.substring(index, last);
        return x
      },
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  padding-bottom: 100px
}

.men_detail {
  background: url(../../../assets/cur_bg.png) repeat-y;
  padding-bottom: changeRem(1.44)+px;
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
  .cur1 {
    background: #fff;
    padding: changeRem(1)+px changeRem(.6)+px changeRem(.8)+px changeRem(.6)+px;
    .cur1_t {
      display: flex;
      display: -webkit-flex;
      .cur1_l {
        color: #EB5032;
        font-size: changeRem(.88)+px;
        margin-right: auto;
        span {
          color: #333;
          font-size: changeRem(.52)+px;
        }
      }
      .cur1_r {
        color: #fff;
        font-size: changeRem(.48)+px;
        margin-left: auto;
        width: changeRem(5.9)+px;
        height: changeRem(.8)+px;
        line-height: changeRem(.8)+px;
        background: rgba(235, 80, 50, 1);
        text-align: center;
        position: relative;
        span {
          position: absolute;
          width: 0;
          height: 0;
          line-height: 0;
          border-right: changeRem(.2)+px solid #EB5032;
          border-bottom: changeRem(.2)+px solid #fff;
          border-top: changeRem(.2)+px solid #fff;
          left: changeRem(-.2)+px;
          top: changeRem(.2)+px;
        }
      }
    }
    .cur1_b {
      margin-right: auto;
      margin-top: changeRem(.65)+px;
      background: url(../../../assets/cur1.png) no-repeat;
      background-size: cover;
      width: changeRem(6.6)+px;
      line-height: changeRem(1.4)+px;
      height: changeRem(1.4)+px;
      text-align: center;
      color: #EB5032;
      font-size: changeRem(.52)+px;
    }
  }
  .cur2 {
    border: 1px solid #333;
    background: #fff;
    width: changeRem(13.82)+px;
    margin: 0 auto;
    margin-top: changeRem(1)+px;
    text-align: center;
    padding: changeRem(.72)+px 0;
    .cur2_t {
      background: url(../../../assets/cur2.png) no-repeat;
      background-size: cover;
      width: changeRem(11.36)+px;
      height: changeRem(2.86)+px;
      line-height: changeRem(.92)+px;
      text-align: center;
      color: #fff;
      font-size: changeRem(.6)+px;
      margin: 0 auto;
      padding-top: changeRem(.5)+px;
    }
    img.cur_img1 {
      width: changeRem(3.26)+px;
      margin-top: changeRem(.8)+px;
    }
    ul.cur_ul1 {
      padding: 0 changeRem(1.2)+px 0 changeRem(.76)+px;
      li {
        margin-top: changeRem(1)+px;
        i {
          width: changeRem(.44)+px;
          height: changeRem(.44)+px;
          display: inline-block;
          background: #EC5538;
          border-radius: 50%;
          float: left;
          margin-top: changeRem(.2)+px;
        }
        .ul1_r {
          width: changeRem(10.8)+px;
          float: right;
          color: #333;
          font-size: changeRem(.52)+px;
          line-height: changeRem(.76)+px;
          text-align: justify;
          span {
            font-weight: 700;
          }
        }
      }
    }
    .cur_rt {
      margin: 0 auto;
      margin-top: changeRem(1.2)+px;
      width: changeRem(11.76)+px;
      height: changeRem(5.08)+px;
      padding-top: changeRem(.6)+px;
      background: url(../../../assets/cur4.png) no-repeat;
      background-size: cover;
      color: #F5831E;
      line-height: changeRem(1)+px;
      font-size: changeRem(.52)+px;
    }
    .cur_tr {
      h2 {
        font-size: changeRem(.52)+px;
        color: #F5831E;
        margin-top: changeRem(.52)+px;
        span {
          width: changeRem(2.24)+px;
          height: 1px;
          background: #F5831E;
          display: inline-block;
          margin: 0 changeRem(.528)+px;
          vertical-align: middle;
        }
      }
      .cur_rtb {
        background: url(../../../assets/cur5.png) no-repeat;
        background-size: cover;
        margin: 0 auto;
        margin-top: changeRem(.6)+px;
        width: changeRem(11.92)+px;
        height: changeRem(2.6)+px;
        line-height: changeRem(.68)+px;
        padding-top: changeRem(.2)+px;
        color: #fff;
        font-size: changeRem(.52)+px;
      }
    }
    img.imr_cur6 {
      width: changeRem(13.34)+px;
      margin-top: changeRem(1)+px;
    }
    .cur2_nv {
      background-image: url(../../../assets/cur16.png);
      height: changeRem(1.84)+px;
      line-height: changeRem(1.84)+px;
      padding-top: 0;
      background-size: cover;
      width: changeRem(12.5)+px;
    }
    .nv_v {
      line-height: changeRem(.8)+px;
      font-size: changeRem(.56)+px;
      color: #333;
      font-weight: 700;
      margin-top: changeRem(.6)+px;
    }
    img.cur_img2 {
      width: changeRem(2.96)+px;
      margin-top: changeRem(0.66)+px;
    }
    ul.cur_ul5 {
      li {
        font-size: changeRem(0.52)+px;
        color: #333;
        line-height: changeRem(0.56)+px;
        width: changeRem(12.4)+px;
        margin: 0 auto;
        margin-top: changeRem(0.4)+px;
        span {
          width: changeRem(.6)+px;
          height: changeRem(.6)+px;
          display: inline-block;
          text-align: center;
          line-height: changeRem(.6)+px;
          color: #fff;
          font-size: changeRem(.48)+px;
        }
      }
    }
  }
  .cur2_tv {
    h2 {
      font-size: changeRem(1)+px;
      line-height: changeRem(1.6)+px;
      font-weight: 700;
    }
    .cur2_tb {
      width: changeRem(8.6)+px;
      margin: 0 auto;
      margin-top: changeRem(.6)+px;
      padding: changeRem(.4)+px;
      border: 1px solid #F5831E;
      .cur2_tn {
        background: #F5831E;
        padding: changeRem(.54)+px 0 changeRem(1.34)+px 0;
        font-size: changeRem(.72)+px;
        line-height: changeRem(1.2)+px;
        color: #fff;
      }
    }
  }
  .cur_son {
    width: changeRem(9.06)+px;
    height: changeRem(1.92)+px;
    background: rgba(235, 80, 50, 1);
    border-radius: changeRem(.96)+px;
    margin-top: changeRem(1)+px;
    margin-left: changeRem(.6)+px;
    span {
      display: inline-block;
      background: #F57F17;
      width: changeRem(1.92)+px;
      line-height: changeRem(1.92)+px;
      color: #fff;
      font-size: changeRem(1)+px;
      border-radius: 50%;
      float: left;
    }
    .cur_sonr {
      float: right;
      margin-right: changeRem(.55)+px;
      line-height: changeRem(.8)+px;
      color: #fff;
      font-size: changeRem(.56)+px;
      padding-top: changeRem(.15)+px;
      text-align: justify;
    }
  }
  .cur3_tv {
    margin-top: changeRem(.6)+px;
    h2 {
      padding: 0 changeRem(.6)+px;
      color: #333;
      font-size: changeRem(.52)+px;
      line-height: changeRem(.96)+px;
      text-align: justify;
      span {
        font-weight: 700;
      }
    }
    ul.cur3_ul {
      li {
        margin: 0 auto;
        margin-top: changeRem(.92)+px;
        border: 1px solid #F5831E;
        width: changeRem(13.24)+px;
        .cur_li {
          margin-top: changeRem(-.5)+px;
          margin-left: changeRem(.56)+px;
          margin-right: changeRem(.32)+px;
          h2 {
            background: #F57F17;
            line-height: changeRem(.88)+px;
            border-radius: changeRem(.08)+px;
            color: #fff;
            font-size: changeRem(.52)+px;
            float: left;
          }
          img {
            width: changeRem(1.08)+px;
            float: right;
          }
        }
        h3 {
          color: #F5831E;
          font-size: changeRem(.48)+px;
          line-height: changeRem(.96)+px;
          padding: 0 changeRem(.64)+px;
          text-align: justify;
          padding-bottom: changeRem(.6)+px;
        }
      }
    }
    ul.cur4_ul {
      padding: changeRem(.68)+px;
      li {
        .ul4_l {
          float: left;
          h1 {
            width: changeRem(.52)+px;
            height: changeRem(.52)+px;
            background: rgba(245, 131, 30, .3);
            border-radius: 50%;
            position: relative;
            span {
              width: changeRem(.28)+px;
              height: changeRem(.28)+px;
              background: rgba(245, 131, 30, 1);
              border-radius: 50%;
              display: inline-block;
              position: absolute;
              left: changeRem(.12)+px;
              top: changeRem(.12)+px;
            }
          }
          h3 {
            background: #F5831E;
            width: 1px;
            height: changeRem(3.4)+px;
            margin-left: changeRem(.25)+px;
          }
        }
        .ul4_r {
          width: changeRem(11.44)+px;
          float: right;
          text-align: justify;
          h3 {
            color: #F5831E;
            font-size: changeRem(.6)+px;
            line-height: changeRem(.8)+px;
          }
          p {
            color: #333;
            font-size: changeRem(.48)+px;
            line-height: changeRem(.8)+px;
            margin-top: changeRem(.2)+px;
          }
        }
      }
    }
    .gd {
      img.gd_i {
        width: changeRem(10.3)+px;
        margin-top: changeRem(1.2)+px;
      }
      p {
        width: changeRem(12)+px;
        margin: 0 auto;
        font-size: changeRem(.52)+px;
        line-height: changeRem(.96)+px;
        color: #F5831E;
        text-align: justify;
      }
      h3 {
        width: changeRem(12.5)+px;
        margin: 0 auto;
        font-size: changeRem(.52)+px;
        line-height: changeRem(.96)+px;
        color: #333;
        text-align: justify;
        margin-top: changeRem(1.4)+px;
      }
      h1 {
        width: changeRem(12.5)+px;
        margin: 0 auto;
        font-size: changeRem(.68)+px;
        line-height: changeRem(.96)+px;
        color: #1E2022;
        text-align: right;
        font-weight: 700;
      }
    }
    img.zd_i {
      width: changeRem(5.88)+px;
      margin-top: changeRem(1.28)+px;
    }
    img.zd_v {
      width: changeRem(10.6)+px;
      margin-top: changeRem(1.28)+px;
    }
    p.zs {
      color: #333;
      font-size: changeRem(0.56)+px;
      margin-top: changeRem(.6)+px;
    }
    img.hz_v {
      width: changeRem(13.32)+px;
      margin-top: changeRem(.8)+px;
    }
    ul.lq {
      li {
        width: changeRem(7.1)+px;
        margin: 0 auto;
        line-height: changeRem(.8)+px;
        font-size: changeRem(.6)+px;
        color: #333;
        margin-top: changeRem(1)+px;
        text-align: justify;
        span {
          display: inline-block;
          width: changeRem(.44)+px;
          height: changeRem(.44)+px;
          background: #EB5032;
          border-radius: 50%;
          margin-right: changeRem(.6)+px;
        }
      }
    }
  }
  .cur_son1 {
    width: 690px
  }
  .cur6 {
    h1 {
      line-height: changeRem(1.2)+px;
      font-size: changeRem(0.56)+px;
      color: #333;
    }
    img.cur_18 {
      width: changeRem(1)+px;
      margin-top: changeRem(1.32)+px;
    }
    a.cur_href {
      width: changeRem(3.8)+px;
      line-height: changeRem(1.12)+px;
      color: #fff;
      margin: 0 auto;
      display: block;
      margin-top: changeRem(0.76)+px;
      font-size: changeRem(0.72)+px;
      background: #EB5032;
    }
    h3.lp {
      line-height: changeRem(.68)+px;
      font-size: changeRem(.68)+px;
      color: #333;
      margin-top: changeRem(.54)+px;
    }
  }
  .cur_xz {
    width: 100%;
    padding: 0 changeRem(.6)+px;
    margin: 0 auto;
    margin-top: changeRem(1)+px;
    text-align: justify;
    h2 {
      color: #EB5032;
      font-size: changeRem(.56)+px;
      line-height: changeRem(.8)+px;
      font-weight: 700;
    }
    p {
      color: #EB5032;
      font-size: changeRem(.48)+px;
      line-height: changeRem(.72)+px;
    }
  }
}

// 按钮
.into_btn_box {
  background: #fff;
  width: 100%;
  max-width: 750px;
  line-height: changeRem(1.96)+px;
  height: auto;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: changeRem(.68)+px;
  .into_project {
    display: block;
    width: 100%;
    line-height: changeRem(1.96)+px;
    text-align: center;
    background: rgba(235, 80, 50, 1);
    text-align: center;
    color: #fff;
  }
  .into_btn {
    display: flex;
  }
  .free_learn {
    color: #EB5032;
    display: block;
    width: 214px;
    text-align: center;
  }
  .sign_immediately {
    flex: 1;
    background-color: #EB5032;
    color: #fff;
  }
}
</style>
